module.exports = __webpack_public_path__ + "assets/img/section-3-landing-page-right-pic.7879ed0c.png";